<mat-card class="emergencia-avl-dialog">
  <app-card-header
    [title]="
      activaAhora
        ? 'Emergencia AVL activa'
        : esAjuste
          ? 'Ajustar emergencia AVL'
          : 'Declarar emergencia AVL'
    "
    [subtitle]="data.nombreEntidad"
    icono="emergency_share"
    [botonCerrar]="true"
    (cerrar)="dialogRef.close()"
  ></app-card-header>

  <mat-card-content
    class="card-content-crear contenido-emergencia"
    [formGroup]="form"
  >
    @if (faltaConfig) {
      <div class="aviso">
        <mat-icon>warning</mat-icon>
        <span>
          El cliente no tiene la integración Objetivos AVL activa o le faltan la
          URL y el token. Cargalos en la ficha del cliente antes de declarar la
          emergencia.
        </span>
      </div>
    } @else if (!form.value.deviceid) {
      <div class="aviso">
        <mat-icon>warning</mat-icon>
        <span>
          El vehículo no tiene patente ni el tracker ID único, así que no hay
          con qué identificar el objetivo ante Suite911.
        </span>
      </div>
    } @else if (buscandoVigente) {
      <div class="intro">Buscando si ya hay una emergencia declarada…</div>
    } @else if (activaAhora) {
      <!-- Ya transmitiendo: tiene que quedar claro que NO se declara otra, sino
           que se extiende o se detiene la que corre. -->
      <div class="estado-activa">
        <span class="pulso"></span>
        <div>
          <strong>Ya se está transmitiendo a Policía de la Ciudad</strong>
          <span>
            {{ periodoActivo }}. Podés extenderla o detenerla; no se declara una
            nueva.
          </span>
        </div>
      </div>
    } @else {
      <div class="intro">
        Se transmite la posición del vehículo a Policía de la Ciudad hasta que
        venza el período. El corte es automático.
      </div>
    }

    <mat-form-field subscriptSizing="dynamic">
      <mat-label>Device ID</mat-label>
      <input matInput formControlName="deviceid" readonly />
      <mat-icon matPrefix>fingerprint</mat-icon>
      <mat-icon matSuffix class="icono-bloqueado">lock</mat-icon>
      <mat-hint>
        @if (usaIdUnico) {
          El vehículo no tiene patente: se usa el ID único del tracker. Es el
          que hay que cargar al declarar la emergencia en e911
        } @else {
          Patente del vehículo. Es la que hay que cargar al declarar la
          emergencia en e911
        }
      </mat-hint>
    </mat-form-field>

    <mat-form-field subscriptSizing="dynamic">
      <mat-label>Nro. de Carta Policial</mat-label>
      <input matInput formControlName="nroCarta" />
      <mat-icon matPrefix>assignment</mat-icon>
      <mat-hint>Opcional, para trazabilidad</mat-hint>
    </mat-form-field>

    <mat-form-field subscriptSizing="dynamic">
      <mat-label>
        {{ esAjuste ? 'Extender por (minutos)' : 'Duración (minutos)' }}
      </mat-label>
      <input
        matInput
        type="number"
        min="1"
        formControlName="duracion"
        [matAutocomplete]="autoDuracion"
      />
      <mat-icon matPrefix>timer</mat-icon>
      <mat-autocomplete #autoDuracion="matAutocomplete">
        @for (d of duraciones; track d.minutos) {
          <mat-option [value]="d.minutos">{{ d.label }}</mat-option>
        }
      </mat-autocomplete>
      <mat-hint>
        @if (duracionEnPalabras) {
          {{ duracionEnPalabras }}. Elegí una sugerencia o escribí los minutos
        } @else {
          Elegí una sugerencia o escribí los minutos
        }
      </mat-hint>
    </mat-form-field>

    <!-- Siempre presente: si apareciera y desapareciera con la duración, el
         dialog cambiaría de alto cada vez que se borra el campo para tipear
         otro número. -->
    <div class="resumen" [class.vacio]="!fin">
      <mat-icon>timer_off</mat-icon>
      <span>
        @if (fin) {
          @if (esAjuste) {
            El nuevo corte queda el
          } @else {
            La transmisión se corta sola el
          }
          <strong>{{ fin | date: 'dd/MM/yyyy HH:mm' }}</strong>
        } @else {
          Ingresá la duración para ver cuándo corta
        }
      </span>
    </div>

    @if (esAjuste && puedeVerEnvios) {
      <div class="envios">
        <div class="envios-header">
          <span>Últimos envíos a Suite911</span>
          <button
            irxBotonIcono tooltip="Actualizar"
            class="btn-refrescar"
            [disabled]="cargandoEnvios"
            (click)="listarEnvios()"
          >
            <mat-icon>refresh</mat-icon>
          </button>
        </div>
        @if (!envios && cargandoEnvios) {
          <mat-spinner diameter="20"></mat-spinner>
        } @else if (!envios?.length) {
          <span class="envios-vacio">
            Todavía no se registró ningún envío para esta emergencia
          </span>
        } @else {
          @for (e of envios; track e._id) {
            <div class="envio" [class.rechazado]="!e.ack">
              <mat-icon>{{ e.ack ? 'check_circle' : 'error' }}</mat-icon>
              <span class="envio-fecha">
                {{ e.fecha | date: 'dd/MM/yyyy HH:mm:ss' }}
              </span>
              <span class="envio-estado">
                {{ e.ack ? 'Recibido' : e.error || 'Rechazado' }}
              </span>
            </div>
          }
        }
      </div>
    }
  </mat-card-content>

  <mat-card-actions class="actions-create">
    <button irxBoton="secundario" type="button" (click)="dialogRef.close()">
      Cancelar
    </button>
    @if (esAjuste) {
      <button
        irxBoton="peligro-borde"
        [disabled]="guardando"
        (click)="detener()"
      >
        <mat-icon>stop_circle</mat-icon>
        Detener ahora
      </button>
    }
    <button
      irxBoton="principal"
      [disabled]="!puedeGuardar"
      (click)="guardar()"
    >
      @if (guardando) {
        <mat-spinner diameter="18"></mat-spinner>
      } @else {
        <mat-icon>{{ esAjuste ? 'save' : 'play_arrow' }}</mat-icon>
      }
      {{
        activaAhora
          ? 'Extender'
          : esAjuste
            ? 'Guardar cambios'
            : 'Declarar emergencia'
      }}
    </button>
  </mat-card-actions>
</mat-card>
